export const OPEN_LOADING_OVERLAY = 'LoadingOverlay/OPEN_LOADING_OVERLAY';
export const CLOSE_LOADING_OVERLAY = 'LoadingOverlay/CLOSE_LOADING_OVERLAY';
